export default {
  shared_breadcrumb_back_btn: "Back",
  shared_flat_list_empty_msg: "No items found",
  shared_flat_list_no_title: "No title",
  shared_flat_table_empty_msg: "No records found",
  shared_cliente_company_label: "Company:",
  shared_cliente_phone_label: "Phone:",
  shared_cliente_cnpj_label: "CNPJ:",
  shared_cliente_email_label: "E-mail:",
  shared_orcamento_status_label: "Status:",
  shared_quotation_card_waiting: "Budget under review",
  shared_quotation_card_details_btn: "Details",
  shared_quotation_column_no_quotes: "No quotes in this column",
  shared_quotation_column_show_less: "Show less",
  shared_quotation_column_show_more: "See more (#vr0# remaining)",
  shared_quotation_section_show_hide: "Show/Hide",
  shared_estimate_respond_no_estimate: "No estimate loaded.",
  shared_estimate_respond_no_item: "No items",
  shared_estimate_respond_obs_label: "Additional observation",
  shared_estimate_respond_obs_placeholder: "Enter the response...",
  shared_estimate_respond_total_label: "Total Value",
  shared_estimate_respond_finish_btn: "Finish Response",
  shared_estimate_respond_item_details: "Item Details",
  shared_estimate_respond_select_service: "Select Service / Part",
  shared_estimate_respond_filter_label: "Filter",
  shared_estimate_respond_filter_placeholder: "Type to filter...",
  shared_estimate_respond_qty_label: "Quantity",
  shared_estimate_respond_price1_label: "Price 1",
  shared_estimate_respond_price2_label: "Price 2",
  shared_estimate_respond_back_btn: "Back",
  shared_estimate_respond_add_btn: "Add",
  shared_estimate_respond_close_btn: "Close",
  shared_resp_no_client_msg: "No client loaded.",
  shared_resp_client_company: "Company",
  shared_resp_client_name: "Name",
  shared_resp_client_phone: "Phone",
  shared_resp_client_cnpj: "CNPJ",
  shared_resp_client_date: "Date",
  shared_resp_client_email: "E-mail",
  shared_resp_form_items_added: "Items added",
  shared_resp_form_obs_label: "Additional observation",
  shared_resp_form_placeholder: "Enter the response...",
  shared_resp_modal_price: "Price",
  shared_accept_estimate_accepted_title: "Estimate Accepted!",
  shared_accept_estimate_process_error: "Unable to process the request.",
  shared_accept_estimate_modal_title: "✅ Accept Estimate",
  shared_accept_estimate_processing_btn: "Processing...",
  shared_accept_estimate_confirm_btn: "Confirm Acceptance",
  shared_accept_estimate_description: "By confirming, your estimate will be accepted and moved to the next workflow status.",
  shared_accept_estimate_simple_success_msg: "The estimate acceptance was recorded successfully.",
  shared_service_msg_equip_updated: "Equipment updated!",
  shared_service_msg_equip_created: "Equipment registered!",
  shared_service_msg_equip_save_error: "Error saving equipment",
  shared_service_msg_photo_uploaded: "Photo uploaded!",
  shared_service_msg_photo_upload_error: "Error uploading photo",
  shared_service_msg_photo_removed: "Photo removed!",
  shared_service_msg_photo_remove_error: "Error removing photo",
  shared_service_msg_laudo_uploaded: "Report uploaded!",
  shared_service_msg_laudo_upload_error: "Error uploading report",
  shared_service_msg_laudo_removed: "Report removed!",
  shared_service_msg_laudo_remove_error: "Error removing report",
  shared_breadcrumb_details: "Details",
  shared_breadcrumb_equipments: "Equipments",
  shared_breadcrumb_home: "Home",
  shared_breadcrumb_quote_service: "Request Quote",
  shared_breadcrumb_quotations: "My Services",
  shared_breadcrumb_shipping: "Shipping Instructions",
  shared_clients_add_btn: "Add",
  shared_clients_address_label: "Address",
  shared_clients_address_placeholder: "Ex: Flower Street, 123 - Downtown",
  shared_clients_cnpj_invalid: "Invalid CNPJ",
  shared_clients_cnpj_label: "CNPJ",
  shared_clients_cnpj_placeholder: "Ex: 12.345.678/0001-90",
  shared_clients_cnpj_required: "CNPJ is required",
  shared_clients_cpf_invalid: "Invalid CPF",
  shared_clients_cpf_label: "CPF",
  shared_clients_cpf_placeholder: "Ex: 123.456.789-00",
  shared_clients_cpf_required: "CPF is required",
  shared_clients_create_btn: "Create Client",
  shared_clients_delete_btn: "Delete",
  shared_clients_delete_confirm_title: "Confirm Deletion",
  shared_clients_delete_warning: "Are you sure you want to delete {{name}}?",
  shared_clients_edit_btn: "Edit",
  shared_clients_edit_title: "Edit Client",
  shared_clients_email_invalid: "Invalid e-mail",
  shared_clients_email_placeholder: "Ex: contact@company.com",
  shared_clients_filter_doc_placeholder: "Filter by CPF/CNPJ...",
  shared_clients_filter_name_placeholder: "Filter by name...",
  shared_clients_modal_title: "Clients",
  shared_clients_name_placeholder: "Ex: Company LLC or John Doe",
  shared_clients_name_required: "Name / Company Name is required",
  shared_clients_new_title: "New Client",
  shared_clients_no_clients_found: "No clients found",
  shared_clients_obs_placeholder: "Additional client information",
  shared_clients_pagination_next: "Next",
  shared_clients_pf_label: "Individual",
  shared_clients_phone_placeholder: "Ex: (11) 99999-8888",
  shared_clients_pj_label: "Company",
  shared_clients_save_changes_btn: "Save Changes",
  shared_clients_table_actions: "Actions",
  shared_clients_table_document: "CPF / CNPJ",
  shared_clients_table_name: "Name / Company Name",
  shared_clients_table_type: "Type",
  shared_clients_type_required: "Type is required",
  shared_details_add_btn: "Add",
  shared_details_attach_invoice_btn: "Attach Invoice",
  shared_details_attach_modal_title: "Add Invoice (PDF or XML)",
  shared_details_attention_label: "Attention",
  shared_details_btn: "Details",
  shared_details_cancel_btn: "Cancel",
  shared_details_close_btn: "Close",
  shared_details_cnpj_label: "CNPJ:",
  shared_details_company_label: "Company:",
  shared_details_date_label: "Date:",
  shared_details_delete_tooltip: "Delete",
  shared_details_download_info_msg: "The file #vr0# will be downloaded.",
  shared_details_download_tooltip: "Download/View",
  shared_details_email_label: "E-mail:",
  shared_details_enter_name_warning: "Please enter a name for the invoice.",
  shared_details_error_label: "Error",
  shared_details_file_size_label: "Size:",
  shared_details_invoice_name_label: "Invoice Name",
  shared_details_invoice_name_placeholder: "Ex: NF-e 12345",
  shared_details_invoices_title: "🧾 Shipping Invoices",
  shared_details_name_label: "Name:",
  shared_details_no_btn: "No",
  shared_details_no_client_msg: "No client found.",
  shared_details_no_invoices_msg: "No attached invoices.",
  shared_details_phone_label: "Phone:",
  shared_details_remove_invoice_confirm_btn: "Yes, remove",
  shared_details_remove_invoice_title: "Remove Invoice?",
  shared_details_remove_invoice_warning: "This action cannot be undone.",
  shared_details_save_btn: "Save",
  shared_details_see_more_btn: "See More",
  shared_details_select_file_msg: "Click to select the file",
  shared_details_select_file_warning: "Please select a file to upload.",
  shared_details_success_label: "Success",
  shared_details_uploading_btn: "Uploading...",
  shared_details_view_btn: "View",
  shared_details_warning_label: "Warning",
  shared_details_yes_btn: "Yes",
  shared_edit_btn: "Edit",
  shared_equip_brand_label: "Brand:",
  shared_equip_ca_label: "CA:",
  shared_equip_card_code_label: "Code",
  shared_equip_card_details_btn: "Details",
  shared_equip_card_item_label: "Item",
  shared_equip_card_last_rev_label: "Last Rev.",
  shared_equip_card_next_rev_label: "Next Rev.",
  shared_equip_card_pending_status: "PENDING",
  shared_equip_download_label: "Download",
  shared_equip_form_active_label: "Active",
  shared_equip_form_add_photo_after_btn: "Add After Photo",
  shared_equip_form_add_photo_before_btn: "Add Before Photo",
  shared_equip_form_attention_label: "Attention",
  shared_equip_form_back_btn: "Back",
  shared_equip_form_brand_label: "Brand",
  shared_equip_form_ca_label: "CA",
  shared_equip_form_cancel_btn: "Cancel",
  shared_equip_form_close_btn: "Close",
  shared_equip_form_data_section_title: "📌 Equipment Data",
  shared_equip_form_deactivate_warning: "This equipment will be permanently removed if you save this change.",
  shared_equip_form_delete_photo_error: "Could not delete the photo",
  shared_equip_form_error_label: "Error",
  shared_equip_form_last_rev_label: "Last Revision",
  shared_equip_form_laudo_default_desc: "Report uploaded by system",
  shared_equip_form_laudo_default_name: "Technical report",
  shared_equip_form_laudo_name_prompt: "Report name",
  shared_equip_form_laudos_section_title: "📑 Reports",
  shared_equip_form_loading_msg: "Loading...",
  shared_equip_form_location_label: "Location",
  shared_equip_form_model_label: "Model",
  shared_equip_form_next_rev_label: "Next Revision",
  shared_equip_form_no_btn: "No",
  shared_equip_form_obs_label: "Technical Note",
  shared_equip_form_photos_section_title: "📷 Photos",
  shared_equip_form_remove_laudo_title: "Remove this report?",
  shared_equip_form_remove_photo_title: "Remove this photo?",
  shared_equip_form_save_btn: "Save",
  shared_equip_form_save_changes_btn: "Save Changes",
  shared_equip_form_save_equip_btn: "Save Equipment",
  shared_equip_form_save_error: "Could not save the equipment",
  shared_equip_form_save_first_laudos_msg: "Save the equipment first to add reports.",
  shared_equip_form_save_first_photos_msg: "Save the equipment first to add photos.",
  shared_equip_form_save_first_warning: "Attention",
  shared_equip_form_saving_btn: "Saving...",
  shared_equip_form_search_placeholder: "Type to search service",
  shared_equip_form_select_service_error: "Error",
  shared_equip_form_send_laudo_btn: "Send Report (PDF)",
  shared_equip_form_serial_label: "Serial",
  shared_equip_form_service_label: "Linked Service",
  shared_equip_form_success_label: "Success",
  shared_equip_form_understand_btn: "Understood",
  shared_equip_form_upload_laudo_error: "Could not upload the report",
  shared_equip_form_upload_photo_error: "Could not upload the photo",
  shared_equip_form_yes_btn: "Yes",
  shared_equip_item_label: "Item:",
  shared_equip_last_rev_label: "Last Rev.:",
  shared_equip_modal_title: "Quick Equipment Registration",
  shared_equip_model_label: "Model:",
  shared_equip_next_rev_label: "Next Rev.:",
  shared_equip_no_history_msg: "No reports registered.",
  shared_equip_no_photos_msg: "No photos registered.",
  shared_equip_pending_revision_label: "🔴 Pending revision",
  shared_equip_photo_alt: "Equipment photo",
  shared_equip_qr_code_label: "QR Code:",
  shared_equip_serial_label: "Serial:",
  shared_image_modal_alt: "Image modal alt",
  shared_menu_add_equipment: "Add Equipment",
  shared_menu_equipments: "Equipment",
  shared_optional_label: "Optional",
  shared_quotation_client_label: "Client",
  shared_quotation_doc_num: "Doc No.:",
  shared_quotation_table_status: "Status",
}
